import React from 'react';
import Modal from '../../components/Modal';

export default function DeleteCompanyModal({ isOpen, onClose, onConfirm, companyId }) {
  const title = (
    <div style={{
      background: 'linear-gradient(135deg, #dc3545 0%, #c82333 100%)',
      margin: '-24px -24px 0 -24px',
      padding: '24px',
      borderRadius: '12px 12px 0 0',
      borderBottom: '2px solid rgba(255, 255, 255, 0.1)'
    }}>
      <h2 style={{
        margin: '0',
        color: '#ffffff',
        fontSize: '24px',
        fontWeight: '700',
        display: 'flex',
        alignItems: 'center',
        gap: '12px'
      }}>
        <i className="fas fa-exclamation-triangle" style={{ fontSize: '22px' }} />
        Excluir Empresa
      </h2>
    </div>
  );

  const footer = (
    <>
      <button
        onClick={onClose}
        type="button"
        style={{
          background: 'rgba(255, 255, 255, 0.08)',
          border: '1px solid rgba(255, 255, 255, 0.15)',
          color: '#b0b0b0',
          padding: '10px 24px',
          borderRadius: '8px',
          fontWeight: '600',
          fontSize: '14px',
          cursor: 'pointer',
          transition: 'all 0.3s ease'
        }}
        onMouseEnter={(e) => {
          e.target.style.background = 'rgba(255, 255, 255, 0.12)';
          e.target.style.color = '#d0d0d0';
        }}
        onMouseLeave={(e) => {
          e.target.style.background = 'rgba(255, 255, 255, 0.08)';
          e.target.style.color = '#b0b0b0';
        }}
      >
        Fechar
      </button>
      <button
        onClick={onConfirm}
        type="button"
        style={{
          background: 'linear-gradient(135deg, #dc3545 0%, #c82333 100%)',
          border: 'none',
          color: '#ffffff',
          padding: '10px 24px',
          borderRadius: '8px',
          fontWeight: '600',
          fontSize: '14px',
          cursor: 'pointer',
          transition: 'all 0.3s ease',
          boxShadow: '0 4px 15px rgba(220, 53, 69, 0.3)'
        }}
        onMouseEnter={(e) => {
          e.target.style.transform = 'translateY(-2px)';
          e.target.style.boxShadow = '0 6px 20px rgba(220, 53, 69, 0.4)';
        }}
        onMouseLeave={(e) => {
          e.target.style.transform = 'translateY(0)';
          e.target.style.boxShadow = '0 4px 15px rgba(220, 53, 69, 0.3)';
        }}
      >
        Sim, excluir empresa
      </button>
    </>
  );

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={title} footer={footer}>
      <p style={{
        margin: '0 0 24px 0',
        color: '#b0b0b0',
        fontSize: '15px',
        lineHeight: '1.6'
      }}>
        Deseja realmente excluir esta empresa? A empresa será desativada e todos os funcionários vinculados não poderão mais acessar o sistema.
      </p>
      <div style={{
        background: 'rgba(220, 53, 69, 0.15)',
        borderRadius: '8px',
        padding: '16px',
        border: '1px solid rgba(220, 53, 69, 0.4)',
        marginBottom: '24px'
      }}>
        <p style={{
          margin: '0',
          color: '#ff8888',
          fontSize: '14px',
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          fontWeight: '500'
        }}>
          <i className="fas fa-info-circle" />
          Esta ação não pode ser desfeita.
        </p>
      </div>
    </Modal>
  );
}


